var map = {
	"./assets/avatar-1.jpg": 40,
	"./assets/avatar-2.jpg": 41,
	"./assets/avatar-3.jpg": 42,
	"./assets/avatar-4.jpg": 43,
	"./avatar-1.jpg": 44,
	"./avatar-2.jpg": 45,
	"./avatar-3.jpg": 46,
	"./avatar-4.jpg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;